<template>
  <div class="product-list-container">
    <div class="header d-flex flex-direction-column flex-wrap">
      <div class="w-100">
        <div class="custom-row row w-75">
          <div class="col col-lg-5 col-md-5 col-xs-12">
            <search-input
                v-model="SearchProduct"
                placeholder="Search for product"
                class="search-input white_space"
            />
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end w-100">
        <div class="show-active-items marg-top">
          <!--          <input
                        type="checkbox"
                        id="show-active"
                        class="active-checkbox "
                        v-model="isActive"
                    />-->

          <check-box :height="24"
                     :width="24"
                     v-model="isActive"
                     class="check-box-container productActiveOnly mr-4"
                     label="Active Only"/>

          <!--          days O     <label for="show-active">Active Only</label>-->
        </div>

        <div
            @click="$router.push({ name: 'system-admin-add-route-product' })"
            class="">
          <primary-button class="primary-button ">Add Product</primary-button>
        </div>
      </div>
    </div>
    <loader :loading="loading" v-if="loading"/>
    <template v-if="!loading">
      <not-found v-if="isFound"/>
      <div
          v-else
          class="table_div"
          style="width: 100%; overflow-x: auto; overflow-y: hidden"
      >
        <table class="Invoice_table">
          <thead>
          <tr class="Invoice_table_header">
            <th class="product-name">
              Product Name
              <span v-on:click="sorting('up', 'product_name')" class="sorting"
              >&#8593;</span
              >
              <span
                  v-on:click="sorting('down', 'product_name')"
                  class="sorting"
              >&#8595;</span
              >
            </th>
            <th class="created-on">
              Created On
              <span v-on:click="sorting('up', 'created_on')" class="sorting"
              >&#8593;</span
              >
              <span v-on:click="sorting('down', 'created_on')" class="sorting"
              >&#8595;</span
              >
            </th>
            <th class="created-by">Created By</th>
            <th class="type">Type</th>
            <th class="action">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="product in products"
              :key="product.productId"
              :class="{
                active: product.status === 'active',
                inactive: product.status === 'inactive',
              }"
          >
            <th class="user_active product-name">
              <div @click="changeStatus(product)" class="status"></div>
              {{ product.productName }}
            </th>
            <th class="user_active created-on">{{ product.createdOn }}</th>
            <th class="user_active image created-by">
              {{ product.createdBy }}
            </th>
            <th class="user_active type">{{ product.state }}</th>

            <th class="action d-flex h-100 w-100 justify-content-center">
              <span>
              <svg
                  @click="
                    $router.push({
                      name: 'system-admin-add-route-product-company',
                      params: { id: product.productId },
                    })
                  "
                  width="25" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.25 6.75L9 1.5L15.75 6.75V15C15.75 15.3978 15.592 15.7794 15.3107 16.0607C15.0294 16.342 14.6478 16.5 14.25 16.5H3.75C3.35218 16.5 2.97064 16.342 2.68934 16.0607C2.40804 15.7794 2.25 15.3978 2.25 15V6.75Z"
                    stroke="#A5B4CB" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.75 16.5V9H11.25V16.5" stroke="#A5B4CB" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
                </span>
              <span
                  @click="
                    $router.push({
                      name: 'system-admin-edit-route-product',
                      params: { id: product.productId },
                    })
                  "
                  title="Edit">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M7.33331 2.66675H2.66665C2.31302 2.66675 1.97389 2.80722 1.72384 3.05727C1.47379 3.30732 1.33331 3.64646 1.33331 4.00008V13.3334C1.33331 13.687 1.47379 14.0262 1.72384 14.2762C1.97389 14.5263 2.31302 14.6667 2.66665 14.6667H12C12.3536 14.6667 12.6927 14.5263 12.9428 14.2762C13.1928 14.0262 13.3333 13.687 13.3333 13.3334V8.66675"
                      stroke="#A5B4CB" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M12.3333 1.66665C12.5985 1.40144 12.9582 1.25244 13.3333 1.25244C13.7084 1.25244 14.0681 1.40144 14.3333 1.66665C14.5985 1.93187 14.7475 2.29158 14.7475 2.66665C14.7475 3.04173 14.5985 3.40144 14.3333 3.66665L7.99998 9.99999L5.33331 10.6667L5.99998 7.99999L12.3333 1.66665Z"
                      stroke="#A5B4CB" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </span>
              <span title="Delete">
                <svg @click="deleteProduct(product)" width="16" height="16" viewBox="0 0 16 16" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 4H3.33333H14" stroke="#A5B4CB" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M5.33331 3.99992V2.66659C5.33331 2.31296 5.47379 1.97382 5.72384 1.72378C5.97389 1.47373 6.31302 1.33325 6.66665 1.33325H9.33331C9.68694 1.33325 10.0261 1.47373 10.2761 1.72378C10.5262 1.97382 10.6666 2.31296 10.6666 2.66659V3.99992M12.6666 3.99992V13.3333C12.6666 13.6869 12.5262 14.026 12.2761 14.2761C12.0261 14.5261 11.6869 14.6666 11.3333 14.6666H4.66665C4.31302 14.6666 3.97389 14.5261 3.72384 14.2761C3.47379 14.026 3.33331 13.6869 3.33331 13.3333V3.99992H12.6666Z"
                      stroke="#A5B4CB" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.66669 7.33325V11.3333" stroke="#A5B4CB" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.33331 7.33325V11.3333" stroke="#A5B4CB" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </span>
            </th>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="productPagination pl-3">
        <div class="col col-lg-7 col-md-7 col-xs-12 per-page">
          <span class="filter_by mb-2">Show Per Page:</span>
          <div class="primary-input-container choose-type perPage">
            <primary-select
                type="text"
                @input="changePerPage"
                v-model="per_page" :is-cross="false"
                class="choose-type perPage"
                placeholder="Select"
            >
              <option :value="item" v-for="(item, key) in pages" :key="key">
                {{ item }}
              </option>
            </primary-select>
          </div>
        </div>
<!--        <div class="buttons-wrapper">
          <pagination-component
              @change-page="changePage($event)"
              :page="Page"
              :total="totalPage"
              :perPage="per_page"
              :qnt="products.length"
          />
        </div>-->
      </div>
    </template>
  </div>
</template>

<script>
import {format} from "date-fns";
import {mapGetters, mapActions} from "vuex";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    A11yDialog: () => import("@/components/A11yDialog.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
    CheckBox: () => import("@/components/Inputs/CheckBox.vue"),
  },
  computed: {
    ...mapGetters({
      getProducts: "products/getProducts",
      totalPage: "products/getTotalPages",
    }),
    products() {
      return this.getProducts.map((product) => ({
        productName: product.product_name,
        createdOn: format(product.created_on, "YYYY:MM:DD HH:mm:ss"),
        createdBy: product.created_by,
        ownedBy: product.company_name,
        productId: product.product_uuid,
        routingId: product.routing_uuid,
        rateTableId: product.rate_table_uuid,
        status: product.status,
        state: product.public === true ? "public" : "private",
      }));
    },
    loading() {
      return this.$store.getters["products/getLoading"];
    },
  },
  data: () => ({
    product: [],
    rate_table: [],
    rates: [],
    routing: [],
    vendor_product: [],
    vendor_rates: [],
    SearchProduct: "",
    Page: 0,
    dialog: null,
    rate_table_uuid: null,
    routing_uuid: null,
    pages: [10, 50, 100],
    per_page: 10,
    isFound: false,
    isActive: false,
  }),
  created() {
    this.getAllProducts();
  },
  watch: {
    SearchProduct: function () {
      this.Page = 0;
      this.getAllProducts();
    },
    isActive() {
      this.Page = 0;
      this.getAllProducts();
    },
  },
  methods: {
    ...mapActions({
      viewAllProducts: "products/getProductList",
      delete: "products/deleteProduct",
      edit: "products/editProduct",
    }),
    changePerPage(e) {
      this.Page = 0;
      this.getAllProducts();
    },
    changePage(page) {
      this.Page = page;
      this.getAllProducts();
    },
    sorting(type, sortBy) {
      let order_dir = "";
      if (type === "up") {
        order_dir = "desc";
      } else {
        order_dir = "asc";
      }

      this.order_dir = order_dir;
      this.order_by = sortBy;

      this.getAllProducts(order_dir, sortBy);
    },
    getAllProducts(order_dir = "desc", order_by = "created_on") {
      this.isFound = false;
      this.viewAllProducts({
        is_active: this.isActive,
        page: this.Page,
        product_name: this.SearchProduct,
        perPage: this.per_page ? parseInt(this.per_page) : 10,
        order_dir: order_dir,
        order_by: order_by,
      }).then((res) => {
        console.log(res);
        if (!res.length) {
          this.isFound = true;
        }
      });
    },
    async changeStatus(product) {
      try {
        await this.edit({
          id: product.productId,
          product: {
            status: product.status === "active" ? "inactive" : "active",
          },
        });
        this.$snotify.success(
            `Product status has been changed from ${
                product.status === "active" ? "active" : "inactive"
            } to ${product.status === "active" ? "inactive" : "active"}`,
            {
              timeout: 6000,
            }
        );
      } catch (err) {
        this.$snotify.error(err.response.data, {timeout: 6000});
      }
    },
    deleteProduct: async function (product) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this product!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then(async (result) => {
        if (!result.value) {
          return;
        }

        try {
          await this.delete({
            product_uuid: product.productId,
            rate_table_uuid: product.rateTableId,
            routing_uuid: product.routingId,
          });
          this.$swal("Deleted!", "Your product has been deleted.", "success");
        } catch (err) {
          this.$error(err);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>


.filter_by {
  color: #90A0B7;

}

.choose-type {
  width: 80px !important;
}

.productPagination {
  background: white;
  margin-bottom: 100px;
  display: flex;
  margin-top: 20px;
  border-radius: 5px;
}

.sorting {
  font-size: 18px;
  cursor: pointer;
  margin: 0;
}

.per-page {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 0;
}

.perPage {
  width: 120px;
  display: inline-block;
}

.custom-row {
  width: 100%;
  display: flex;

  .show-active-items {
    display: flex;
    align-items: center;
    margin-left: 20px;

    .active-checkbox {
      width: 20px;
      height: 20px;
      margin-right: 10px;

    }

    label {
      margin-bottom: 0;
    }
  }
}

span {
  margin-right: 10px;
}

.table_div {
  .Invoice_table {
    width: 100%;
    margin: 21px auto 0;

    th {
      text-align: center;
    }

    .product-name {
      width: 250px;
    }

    .created-on {
      width: 160px;
    }

    .created-by {
      width: 150px;
    }

    .type {
      width: 100px;
    }

    .action {
      width: 125px;
    }
  }
}

table thead tr {
  background: #7A89FE;
  //background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}

table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 22%;
}

table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}

.Invoice_table tbody tr th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  padding: 7px 10px 7px 20px;
  text-align: left;
}

table tr th {
  padding: 7px 10px 7px 0;
}

table {
  border-collapse: collapse;
}

.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}

.Invoice_table_popup {
  height: 30px;
  text-align: right;
  position: relative;
  padding: 0;
  float: right;

  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}

table thead th:first-child {
  padding-left: 35px;
}

tbody th:first-child {
  padding: 5px 10px 5px 0;

  span {
    padding: 7px 0;
  }
}

tbody th.created_by {
  line-height: 20px;
  height: 20px;
  padding: 7px 0 27px 0;
}

.svg-grey {
  fill: #55616e;
  margin-left: 3px;
}

div.buttons-wrapper {
  width: 100%;
  justify-content: flex-end;
}

@media (max-width: 891px) {
  .right-wrapprr {
    width: 100% !important;
  }
}

@media (max-width: 767px) {
  .header {
    display: block !important;
    height: auto !important;
  }
  .custom-row {
    width: 100% !important;
  }
  .buttons-wrapper {
    width: 100%;
    justify-content: flex-start !important;
    margin-top: 15px;
  }
  .primary-button {
    margin-top: 15px;
  }
}

@media (max-width: 600px) {
  .custom-row {
    display: block !important;
  }

  .buttons-wrapper {
    width: 100% !important;
  }
  .col-lg-6.col-md-7.col-xs-12 {
    margin-top: 15px;
  }
}

.user_active.image span {
  width: 30px;
  height: 30px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
}

.buttons-wrapper {
  display: flex;
  align-items: center;
  width: fit-content;
}

.filter-box {
  display: flex;
  width: 100%;

  span {
    margin-left: 20px;
    margin-right: 12px;
    margin-top: 7px;
  }
}

.perPage {
  width: 120px;
}

.header {
  display: flex;
  justify-content: space-between;
  height: auto;
  margin-bottom: 20px;

  .search-input {
    /*max-width: 345px;*/
    height: 100%;
    max-width: 250px;

    .icon {
      right: 10px;
      position: absolute;
      height: 16px;
      width: 16px;
    }

  }

  .primary-button {
    background: #7A89FE;
    height: 40px;
    width: 140px;
  }
}

.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-grid;
  margin: 0 10px 0 12px;
  float: left;
}

.active {
  th .status {
    background-color: #24e2b8;
  }
}

.inactive {
  // background-color: #f0f1fa;
  th .status {
    background-color: #d2305b;
  }
}

.radio-button.active {
  padding: 2px 3px 3px 23px;
  background-color: #24e2b8;
  border: 0;
}

.radio-button {
  height: 30px;
  width: 50px;
  border-radius: 15px;
  background-color: #ffffff;
  border: 1px solid #a6b6be;
  margin-left: 10px;
  padding: 2px 23px 3px 3px;
  display: inline-block;
  margin-right: 5px;
  cursor: pointer;
}

th.icon .radio-button svg {
  height: 24px;
  width: 24px;
}

@media (max-width: 1320px) {
  .product-list-container table.Invoice_table {
    width: 1020px;
  }
}

.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(0.44, #51a3f3),
          color-stop(0.72, #51a3f3),
          color-stop(0.86, #51a3f3)
  );
}

@media (max-width: 600px) {
  .marg-top {
    margin-top: 20px !important;
  }
}
</style>

